<template>
  <div class="section"> 
    <el-header v-if="!this.$store.state.equipment.isMobile"> 
      <span class="el-icon-close" @click="closePage"></span>
      {{isPreview?'查看用户信息':'编辑用户信息'}}
    </el-header>
    <div class="content">
      <div class="disabled_mask" v-if="isPreview"></div>
      <el-form :model="studentInfo" :rules="rules" ref="studentInfo">
            
      <div class="title">姓名
        <el-form-item  prop="realName">
          <el-input class="input" v-model="studentInfo.realName" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
      </div>
      <div class="title">性别 
        <div class="radio">
          <el-radio v-model="studentInfo.sex" label="男">男</el-radio>
          <el-radio v-model="studentInfo.sex" label="女">女</el-radio>
        </div>
      </div>
      <div class="title">证件号码 

        <el-input class="input" v-if="isPreview" v-model="studentInfo.cardNo" placeholder="请输入证件号码" clearable></el-input>
        <el-form-item v-else prop="cardNo">
          <el-input class="input" v-model="studentInfo.cardNo" placeholder="请输入证件号码" clearable></el-input>
        </el-form-item>
      </div>
      <div class="title">手机号码 
        <el-form-item  prop="mobilePhone">
          <el-input class="input" v-model="studentInfo.mobilePhone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
      </div>
      </el-form>
    </div>
    <div class="footer">
      <el-button v-if="!isPreview" @click="validateInfo()">保存</el-button>
    </div>

    <el-dialog
      title="提示"
      top="30vh"
      :visible.sync="dialogVisible"
      width="300px"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      center>
      <span>修改用户信息会导致该用户账号下的所有的报名信息都会同步修改，是否确认要修改？</span>
      <div slot="footer" class="dialog-footer">
          <el-button  @click="dialogVisible=!dialogVisible">取 消</el-button>
          <el-button class="determine" @click="saveInfo(studentInfo)">确 定</el-button>
        </div>
    </el-dialog>    
  </div>
</template>
<script>
export default {
  data(){
    var checkPhone = (rule, value, callback) => {
      const regExp = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!value) {
      return callback(new Error('手机号不能为空'));
      }else if (!regExp.test(value)) {
          callback(new Error('请输入11位正确的手机号'))
      } else {
          callback();
      }
    }
    return {
      studentInfo:{
        id:'',
        realName:'',
        sex:'',
        cardNo:'',
        mobilePhone:''
      },
      dialogVisible:false,
      rules: {
        mobilePhone: [
          { validator: checkPhone, trigger: 'change' }
        ],
        realName: [
          { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        cardNo:[
          { required: true, message: '请输入证件号码', trigger: 'change' }
        ]
      } 
    }
  },
  created(){
    this.getUserInfo()
  },
  computed:{
    isPreview: function(){
      return this.$route.path.includes('preview')
    }
  },
  methods:{
    getUserInfo(){
      let params ={
        id:this.$route.params.id
      }
      this.$http.get(`/user/management/${params.id}`,{params:params}).then(res => {
        if(res.data.success){
          for(let key of Object.keys(this.studentInfo)){
            this.studentInfo[key] = res.data.data[key]
          }
          
          if(this.studentInfo.sex === 'male'){
            this.studentInfo.sex = '男'
          }else if(this.studentInfo.sex === 'female'){
            this.studentInfo.sex = '女'
          }else{
            this.studentInfo.sex = this.studentInfo.sex
          }
        }
      })
    },
    closePage:function(){
      this.$router.go(-1)
    },
    validateInfo:function(){
      this.$refs["studentInfo"].validate((valid) => { 
        if (valid) {
          this.dialogVisible=true
        }
      })
    },
    saveInfo(){
      let params = {
        ...this.studentInfo
      }
      this.$http.put('/user/management',  params ).then(res=>{
        if(res.data.success){
          this.$message.success("修改信息成功")
          this.$router.push('/userManage')
        }else{
          this.$message.error(`${res.data.msg}`)
        }
      })
      this.dialogVisible = false
    } 
  }
}
</script>
<style scoped>

.section {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0px 30px;
  position: relative;
  display: flex;
  flex-direction: column;
}
.el-header{
  background-color: rgb(245, 245, 245);
  color: #333;
  text-align: center;
  height: 40px !important;
  line-height: 40px !important;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  position: relative;
}
.el-header span{
  position: absolute;
  line-height: 40px;
  left: 5px;
  color: rgb(97, 97, 97);
  font-size: 20px;
}
.content{
  margin-top: 20px;
  margin-bottom: 20px;
}
.title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 60px;
}
.red{
  color: red;
}

.input{
  width: 100%;
  height: 30px;
  margin-top: 20px;
  font-weight: 400;
}
.radio{
  margin-top: 20px;
}
.disabled_mask{
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10000;
}
.footer{
  width: 100%;
  align-self:center;
  justify-self: flex-end;
}
::v-deep .el-dialog__footer{
  width: 100%;
  padding: 0;
  border-top: 2px solid #EDEDED;
    
}

.footer /deep/ .el-button{
  display: block;
  background-color: rgb(84, 177, 250);
  color: #ffffff;
  padding: 0;
  width: 100%;
  height: 50px;
  border-radius: 0;
  border: none;
  font-size: 16px;
}
.dialog-footer{
  width: 100%;
  display:flex;
  height: 120px;
}

.determine{
  color: #54B0FB;
}
.dialog-footer /deep/ .el-button{
  margin: 0;
  padding: 0;
  width: 50%;
  border-radius: 0;
  border: none;
  border-right: 2px solid #EDEDED;
  font-size: 16px;
}
</style>